<div class="hidden md:flex lg:gap-x-12 items-end ">
    @for(item of mainStoreService.whiteLabel?.header?.navigation?.value; track $index){
        @if (!item.navigation.value?.length) {
            <a [routerLink]="item.link.value" class="text-sm/6 font-semibold text-normal">
                @if(item.icon.value){
                    <div class="text-center m-auto" [innerHTML]="item.icon.value | safe: 'html'"></div>
                }
                {{item.label.value}}
            </a>
        } @else {
            <div class="relative">
                <app-dropdown #dropdownComponent
                 [dropdownWidthClass]="'!block'"
                >
                    <div class="dropdown-button">
                        <button type="button" class="flex items-center gap-x-1 text-sm/6 font-semibold text-normal" aria-expanded="false">
                            {{item.label.value}}
                            <svg [ngClass]="{'rotate-180' : dropdownComponent.isOpen}" class="size-5 transition-all duration-300 flex-none text-light" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                                <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="dropdown-options">
                        @for(subItem of item.navigation.value; track $index){
                            @if(!subItem.navigation.value?.length){
                                @if(subItem.icon.value){
                                    <div class="group relative flex gap-x-6 rounded-lg p-4 text-sm/6 hover:bg-card-hover">
                                        <div [innerHTML]="subItem.icon.value | safe: 'html'" class="mt-1 size-6 text-normal group-hover:text-primary-hover flex flex-none items-center justify-center rounded-lg bg-card group-hover:bg-card-hover">
                                        </div>
                                        <div class="flex-auto">
                                            <a [routerLink]="subItem.link.value" class="block font-semibold text-normal leading-5 w-max">
                                                {{subItem.label.value}}
                                                <span class="absolute inset-0"></span>
                                            </a>
                                        </div>
                                    </div>
                                } @else {
                                    <a [routerLink]="subItem.link.value" class="block rounded-lg min-w-full py-2 pl-6 pr-3 text-sm/7 font-semibold text-normal hover:bg-card-hover leading-5 w-max">
                                        {{subItem.label.value}}
                                    </a>
                                }
                            }
                        }
                    </div>
                </app-dropdown>
            </div>
        }
    }
</div>